import { admin as adminApi } from '../api.js';
import { esc, toast, badgeHtml, avatarUrl } from '../utils/dom.js';

export async function renderAdmin(container) {
  container.innerHTML = `
    <div class="admin-tabs">
      <button type="button" class="active" data-tab="users">管理用户</button>
      <button type="button" data-tab="invites">邀请码</button>
      <button type="button" data-tab="broadcast">广播通知</button>
      <button type="button" data-tab="site">站点 Logo</button>
      <button type="button" data-tab="words">敏感词库</button>
    </div>
    <div class="admin-panel" id="admin-panel"></div>
  `;

  const panel = container.querySelector('#admin-panel');
  const tabs = container.querySelectorAll('[data-tab]');

  const setTab = (name) => {
    tabs.forEach((t) => t.classList.toggle('active', t.dataset.tab === name));
    if (name === 'users') renderUsers(panel);
    else if (name === 'invites') renderInvites(panel);
    else if (name === 'broadcast') renderBroadcast(panel);
    else if (name === 'site') renderSite(panel);
    else renderWords(panel);
  };

  tabs.forEach((t) => t.addEventListener('click', () => setTab(t.dataset.tab)));
  setTab('users');
}

function formatBan(u) {
  if (u.is_banned && u.banned_until) {
    return `<span class="ban-badge" title="${esc(u.banned_until)}">封禁至 ${esc(
      String(u.banned_until).slice(0, 16).replace('T', ' ')
    )}</span>`;
  }
  return '<span class="muted text-sm">正常</span>';
}

async function renderUsers(panel) {
  panel.innerHTML = `<div class="center-box"><div class="spinner"></div></div>`;
  try {
    const data = await adminApi.listUsers({ limit: 200 });
    const items = data.items || [];
    panel.innerHTML = `
      <div class="flex justify-between items-center gap-1" style="margin-bottom:1rem;flex-wrap:wrap">
        <span class="text-sm muted">共 ${data.total ?? items.length} 位用户</span>
        <button type="button" class="btn btn-primary btn-sm" id="admin-add-user">新增用户</button>
      </div>
      <div style="overflow-x:auto">
        <table class="admin-table">
          <thead>
            <tr>
              <th>ID</th>
              <th>GID</th>
              <th>昵称</th>
              <th>角色</th>
              <th>蓝V</th>
              <th>状态</th>
              <th>操作</th>
            </tr>
          </thead>
          <tbody>
            ${items
              .map(
                (u) => `
              <tr data-id="${u.id}">
                <td>${u.id}</td>
                <td><code>${esc(u.gid)}</code></td>
                <td>
                  <div class="flex items-center gap-1">
                    <img src="${esc(avatarUrl(u))}" alt="" style="width:28px;height:28px;border-radius:50%" />
                    ${esc(u.nickname)}${badgeHtml(u)}
                  </div>
                </td>
                <td>${esc(u.role)}</td>
                <td class="text-sm">${[
                  u.is_verified ? '蓝V' : '',
                  u.is_teacher ? '红V' : '',
                  u.is_gold ? '金V' : '',
                  u.is_student ? '学生' : '',
                ]
                  .filter(Boolean)
                  .join(' ') || '—'}</td>
                <td>${formatBan(u)}</td>
                <td>
                  <button type="button" class="btn btn-ghost btn-sm" data-edit="${u.id}">编辑</button>
                  <button type="button" class="btn btn-ghost btn-sm" data-bc="${esc(u.gid)}">广播</button>
                </td>
              </tr>`
              )
              .join('')}
          </tbody>
        </table>
      </div>
    `;

    panel.querySelector('#admin-add-user')?.addEventListener('click', () => {
      openUserModal(null, () => renderUsers(panel));
    });
    panel.querySelectorAll('[data-edit]').forEach((btn) => {
      btn.addEventListener('click', () => {
        const id = Number(btn.dataset.edit);
        const user = items.find((u) => u.id === id);
        openUserModal(user, () => renderUsers(panel));
      });
    });
    panel.querySelectorAll('[data-bc]').forEach((btn) => {
      btn.addEventListener('click', () => {
        openQuickBroadcast(btn.dataset.bc);
      });
    });
  } catch (err) {
    panel.innerHTML = `<div class="empty-state"><p style="color:var(--danger)">${esc(
      err.message || '加载失败'
    )}</p></div>`;
  }
}

function openQuickBroadcast(gid) {
  const msg = prompt(`向 GID ${gid} 发送广播通知：`);
  if (msg == null) return;
  const message = msg.trim();
  if (!message) {
    toast('内容不能为空', 'error');
    return;
  }
  adminApi
    .broadcast({ to_gid: gid, message })
    .then((r) => toast(`已发送（${r.sent ?? 1}）`, 'success'))
    .catch((err) => toast(err.message || '发送失败', 'error'));
}

function openUserModal(user, onDone) {
  const isNew = !user;
  document.getElementById('admin-user-modal')?.remove();
  const backdrop = document.createElement('div');
  backdrop.id = 'admin-user-modal';
  backdrop.className = 'modal-backdrop';
  backdrop.innerHTML = `
    <div class="modal">
      <div class="modal-header">
        <h3>${isNew ? '新增用户' : '编辑用户'}</h3>
        <button type="button" class="btn btn-ghost btn-sm" data-close>✕</button>
      </div>
      <div class="modal-body">
        <div class="field">
          <label>昵称</label>
          <input id="au-nickname" value="${esc(user?.nickname || '')}" required />
        </div>
        <div class="field">
          <label>GID ${isNew ? '（可选，留空自动分配）' : ''}</label>
          <input id="au-gid" value="${esc(user?.gid || '')}" />
        </div>
        <div class="field">
          <label>密码 ${isNew ? '' : '（留空不改）'}</label>
          <input id="au-password" type="password" autocomplete="new-password" />
        </div>
        <div class="field">
          <label>邮箱</label>
          <input id="au-email" type="email" value="${esc(user?.email || '')}" />
        </div>
        <div class="field">
          <label>
            <input type="checkbox" id="au-verified" ${user?.is_verified ? 'checked' : ''} />
            蓝 V
          </label>
        </div>
        <div class="field">
          <label>
            <input type="checkbox" id="au-teacher" ${user?.is_teacher ? 'checked' : ''} />
            红 V（认证老师）
          </label>
        </div>
        <div class="field">
          <label>
            <input type="checkbox" id="au-gold" ${user?.is_gold ? 'checked' : ''} />
            金 V（商用）
          </label>
        </div>
        <div class="field">
          <label>
            <input type="checkbox" id="au-student" ${user?.is_student ? 'checked' : ''} />
            学生绿点
          </label>
        </div>
        <div class="field">
          <label>角色</label>
          <select id="au-role">
            <option value="user" ${user?.role !== 'admin' ? 'selected' : ''}>普通用户</option>
            <option value="admin" ${user?.role === 'admin' ? 'selected' : ''}>管理员</option>
          </select>
        </div>
        ${
          isNew
            ? ''
            : `
        <div class="field">
          <label>封禁（天）</label>
          <input id="au-ban-days" type="number" min="0" step="1" placeholder="留空不改；填天数则从现在起封禁" />
          <span class="hint">当前：${
            user?.is_banned && user?.banned_until
              ? `封禁至 ${esc(String(user.banned_until).slice(0, 19).replace('T', ' '))}`
              : '未封禁'
          }</span>
        </div>
        <div class="field">
          <label>
            <input type="checkbox" id="au-unban" />
            立即解封
          </label>
        </div>`
        }
      </div>
      <div class="modal-footer">
        <span></span>
        <button type="button" class="btn btn-primary btn-sm" id="au-save">保存</button>
      </div>
    </div>
  `;
  document.body.appendChild(backdrop);
  const close = () => backdrop.remove();
  backdrop.addEventListener('click', (e) => {
    if (e.target === backdrop) close();
  });
  backdrop.querySelector('[data-close]')?.addEventListener('click', close);

  backdrop.querySelector('#au-save')?.addEventListener('click', async () => {
    const nickname = backdrop.querySelector('#au-nickname').value.trim();
    const gid = backdrop.querySelector('#au-gid').value.trim();
    const password = backdrop.querySelector('#au-password').value;
    const email = backdrop.querySelector('#au-email').value.trim();
    const is_verified = backdrop.querySelector('#au-verified').checked;
    const is_teacher = backdrop.querySelector('#au-teacher')?.checked;
    const is_gold = backdrop.querySelector('#au-gold')?.checked;
    const is_student = backdrop.querySelector('#au-student')?.checked;
    const role = backdrop.querySelector('#au-role').value;
    if (!nickname) {
      toast('请填写昵称', 'error');
      return;
    }
    if (isNew && (!password || password.length < 6)) {
      toast('新用户密码至少 6 位', 'error');
      return;
    }
    const btn = backdrop.querySelector('#au-save');
    btn.disabled = true;
    try {
      if (isNew) {
        await adminApi.createUser({
          nickname,
          password,
          gid: gid || undefined,
          email: email || undefined,
          is_verified,
          role,
        });
        toast('用户已创建', 'success');
      } else {
        const payload = {
          nickname,
          is_verified,
          is_teacher: !!is_teacher,
          is_gold: !!is_gold,
          is_student: !!is_student,
          role,
          email: email || null,
        };
        if (gid && gid !== user.gid) payload.gid = gid;
        if (password) payload.password = password;
        const unban = backdrop.querySelector('#au-unban')?.checked;
        const banDaysRaw = backdrop.querySelector('#au-ban-days')?.value;
        if (unban) {
          payload.unban = true;
        } else if (banDaysRaw != null && String(banDaysRaw).trim() !== '') {
          const days = Number(banDaysRaw);
          if (!Number.isFinite(days) || days <= 0) {
            toast('封禁天数须为正数', 'error');
            btn.disabled = false;
            return;
          }
          payload.ban_days = days;
        }
        await adminApi.updateUser(user.id, payload);
        toast('用户已更新', 'success');
      }
      close();
      onDone?.();
    } catch (err) {
      toast(err.message || '保存失败', 'error');
      btn.disabled = false;
    }
  });
}

async function renderInvites(panel) {
  panel.innerHTML = `<div class="center-box"><div class="spinner"></div></div>`;
  try {
    const data = await adminApi.listInviteCodes();
    const items = data.items || [];
    panel.innerHTML = `
      <div class="admin-card" style="margin-bottom:1rem">
        <h3 style="margin:0 0 0.75rem;font-size:1.05rem">新建邀请码</h3>
        <div class="field">
          <label>邀请码内容</label>
          <input id="inv-code" placeholder="例如 GSORG-STU-2026" />
        </div>
        <div class="field">
          <label>类型</label>
          <select id="inv-type">
            <option value="student">学生邀请码（绿点，可多次使用）</option>
            <option value="teacher">老师邀请码（红V，单次有效）</option>
          </select>
        </div>
        <div class="field" id="inv-max-wrap">
          <label>最大使用次数（学生码可选，留空不限）</label>
          <input id="inv-max" type="number" min="1" placeholder="留空 = 不限次数" />
        </div>
        <div class="field">
          <label>有效天数（可选）</label>
          <input id="inv-days" type="number" min="1" placeholder="留空 = 永不过期" />
        </div>
        <div class="field">
          <label>备注</label>
          <input id="inv-note" placeholder="可选" />
        </div>
        <button type="button" class="btn btn-primary btn-sm" id="inv-create">创建</button>
      </div>
      <div style="overflow-x:auto">
        <table class="admin-table">
          <thead>
            <tr>
              <th>码</th>
              <th>类型</th>
              <th>已用/上限</th>
              <th>过期</th>
              <th>备注</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            ${
              items.length
                ? items
                    .map(
                      (c) => `
              <tr>
                <td><code>${esc(c.code)}</code></td>
                <td>${c.type === 'teacher' ? '老师' : '学生'}</td>
                <td>${c.used_count ?? 0} / ${c.max_uses == null ? '∞' : c.max_uses}</td>
                <td class="text-sm">${c.expires_at ? esc(String(c.expires_at).slice(0, 16).replace('T', ' ')) : '永不过期'}</td>
                <td class="text-sm">${esc(c.note || '')}</td>
                <td><button type="button" class="btn btn-ghost btn-sm" data-del-inv="${c.id}">删除</button></td>
              </tr>`
                    )
                    .join('')
                : `<tr><td colspan="6" class="muted">暂无邀请码</td></tr>`
            }
          </tbody>
        </table>
      </div>
    `;

    const typeEl = panel.querySelector('#inv-type');
    const maxWrap = panel.querySelector('#inv-max-wrap');
    const syncType = () => {
      maxWrap.style.display = typeEl.value === 'teacher' ? 'none' : '';
    };
    typeEl?.addEventListener('change', syncType);
    syncType();

    panel.querySelector('#inv-create')?.addEventListener('click', async () => {
      const code = panel.querySelector('#inv-code').value.trim();
      const type = panel.querySelector('#inv-type').value;
      const maxRaw = panel.querySelector('#inv-max').value;
      const daysRaw = panel.querySelector('#inv-days').value;
      const note = panel.querySelector('#inv-note').value.trim();
      if (!code) {
        toast('请填写邀请码', 'error');
        return;
      }
      try {
        await adminApi.createInviteCode({
          code,
          type,
          max_uses: maxRaw ? Number(maxRaw) : undefined,
          valid_days: daysRaw ? Number(daysRaw) : undefined,
          note: note || undefined,
        });
        toast('邀请码已创建', 'success');
        renderInvites(panel);
      } catch (err) {
        toast(err.message || '创建失败', 'error');
      }
    });

    panel.querySelectorAll('[data-del-inv]').forEach((btn) => {
      btn.addEventListener('click', async () => {
        if (!confirm('删除该邀请码？')) return;
        try {
          await adminApi.removeInviteCode(btn.dataset.delInv);
          toast('已删除', 'success');
          renderInvites(panel);
        } catch (err) {
          toast(err.message || '删除失败', 'error');
        }
      });
    });
  } catch (err) {
    panel.innerHTML = `<div class="empty-state"><p style="color:var(--danger)">${esc(
      err.message || '加载失败'
    )}</p></div>`;
  }
}

async function renderBroadcast(panel) {
  panel.innerHTML = `
    <div class="admin-card">
      <h3 style="margin:0 0 0.75rem;font-size:1.05rem">发送广播通知</h3>
      <p class="text-sm muted" style="margin:0 0 1rem">用户将在右上角铃铛「提醒」中看到消息。</p>
      <div class="field">
        <label>目标</label>
        <select id="bc-target">
          <option value="gid">指定 GID</option>
          <option value="all">全部用户</option>
        </select>
      </div>
      <div class="field" id="bc-gid-wrap">
        <label>目标 GID</label>
        <input id="bc-gid" placeholder="例如 101 或 root" />
      </div>
      <div class="field">
        <label>消息内容</label>
        <textarea id="bc-msg" rows="4" maxlength="2000" placeholder="通知正文…"></textarea>
      </div>
      <button type="button" class="btn btn-primary btn-sm" id="bc-send">发送</button>
    </div>
  `;

  const target = panel.querySelector('#bc-target');
  const gidWrap = panel.querySelector('#bc-gid-wrap');
  target?.addEventListener('change', () => {
    gidWrap.style.display = target.value === 'all' ? 'none' : '';
  });

  panel.querySelector('#bc-send')?.addEventListener('click', async () => {
    const message = panel.querySelector('#bc-msg').value.trim();
    if (!message) {
      toast('请填写消息', 'error');
      return;
    }
    const mode = target.value;
    const btn = panel.querySelector('#bc-send');
    btn.disabled = true;
    try {
      let res;
      if (mode === 'all') {
        if (!confirm('确认向全部用户发送广播？')) {
          btn.disabled = false;
          return;
        }
        res = await adminApi.broadcast({ to_all: true, message });
      } else {
        const to_gid = panel.querySelector('#bc-gid').value.trim();
        if (!to_gid) {
          toast('请填写 GID', 'error');
          btn.disabled = false;
          return;
        }
        res = await adminApi.broadcast({ to_gid, message });
      }
      toast(`广播已发送（${res.sent ?? 0} 人）`, 'success');
      panel.querySelector('#bc-msg').value = '';
    } catch (err) {
      toast(err.message || '发送失败', 'error');
    } finally {
      btn.disabled = false;
    }
  });
}

async function renderSite(panel) {
  panel.innerHTML = `<div class="center-box"><div class="spinner"></div></div>`;
  try {
    const data = await adminApi.getSettings();
    const logo = data.site_logo_url || '';
    panel.innerHTML = `
      <div class="admin-card">
        <h3 style="margin:0 0 0.75rem;font-size:1.05rem">侧栏 Logo（GSORG 右侧）</h3>
        <p class="text-sm muted" style="margin:0 0 1rem">填写图片链接（http/https 或本站 /api/files/...）。留空则不显示。</p>
        <div class="field">
          <label>图片链接</label>
          <input id="site-logo-url" value="${esc(logo)}" placeholder="https://example.com/logo.png" />
        </div>
        <div class="site-logo-preview-wrap">
          <span class="text-sm muted">预览：</span>
          <div class="site-logo-preview-brand">
            <div class="sidebar-brand-mark">GS</div>
            <span>GSORG</span>
            <img id="site-logo-preview" class="sidebar-site-logo" alt="logo" style="${
              logo ? '' : 'display:none'
            }" src="${esc(logo)}" />
          </div>
        </div>
        <button type="button" class="btn btn-primary btn-sm" id="site-logo-save" style="margin-top:1rem">保存</button>
      </div>
    `;

    const input = panel.querySelector('#site-logo-url');
    const preview = panel.querySelector('#site-logo-preview');
    input?.addEventListener('input', () => {
      const v = input.value.trim();
      if (v) {
        preview.style.display = '';
        preview.src = v;
      } else {
        preview.style.display = 'none';
        preview.removeAttribute('src');
      }
    });

    panel.querySelector('#site-logo-save')?.addEventListener('click', async () => {
      const site_logo_url = input.value.trim();
      try {
        await adminApi.updateSettings({ site_logo_url });
        toast('Logo 已保存，刷新页面后侧栏可见', 'success');
        window.dispatchEvent(new CustomEvent('gsorg:logo', { detail: { siteLogoUrl: site_logo_url || null } }));
      } catch (err) {
        toast(err.message || '保存失败', 'error');
      }
    });
  } catch (err) {
    panel.innerHTML = `<div class="empty-state"><p style="color:var(--danger)">${esc(
      err.message || '加载失败'
    )}</p></div>`;
  }
}

async function renderWords(panel) {
  panel.innerHTML = `<div class="center-box"><div class="spinner"></div></div>`;
  try {
    const data = await adminApi.listSensitiveWords();
    const items = data.items || [];
    panel.innerHTML = `
      <form id="word-form" class="flex gap-1" style="margin-bottom:1rem;flex-wrap:wrap">
        <input id="word-input" placeholder="新增敏感词" style="flex:1;min-width:160px;padding:0.6rem 0.9rem;border-radius:10px;border:1px solid var(--border);background:var(--input-bg)" />
        <button type="submit" class="btn btn-primary btn-sm">添加</button>
      </form>
      <div id="word-list">
        ${
          items.length
            ? items
                .map(
                  (w) => `
          <span class="word-chip" data-id="${w.id}">
            ${esc(w.word)}
            <button type="button" data-del="${w.id}" title="删除">×</button>
          </span>`
                )
                .join('')
            : `<div class="empty-state"><p>暂无敏感词</p></div>`
        }
      </div>
    `;

    panel.querySelector('#word-form')?.addEventListener('submit', async (e) => {
      e.preventDefault();
      const input = panel.querySelector('#word-input');
      const word = input.value.trim();
      if (!word) return;
      try {
        await adminApi.addSensitiveWord(word);
        toast('已添加', 'success');
        renderWords(panel);
      } catch (err) {
        toast(err.message || '添加失败', 'error');
      }
    });

    panel.querySelectorAll('[data-del]').forEach((btn) => {
      btn.addEventListener('click', async () => {
        if (!confirm('删除该敏感词？')) return;
        try {
          await adminApi.removeSensitiveWord(btn.dataset.del);
          toast('已删除', 'success');
          renderWords(panel);
        } catch (err) {
          toast(err.message || '删除失败', 'error');
        }
      });
    });
  } catch (err) {
    panel.innerHTML = `<div class="empty-state"><p style="color:var(--danger)">${esc(
      err.message || '加载失败'
    )}</p></div>`;
  }
}
